<template>
    <div>
        システムエラーが発生しました。<br>
        システム管理者へ連絡してください。
    </div>
</template>